import React from "react";
import { Route } from "react-router-dom";

const HomePageP2 = React.lazy(() => import("../containers/CallCenterLayout/Home"));
const PharmacyLayout2 = React.lazy(() => import("../containers/CallCenterLayout"));
const ElectronicRecipes2 = React.lazy(
  () => import("../containers/CallCenterLayout/electronic-recipes-view/Electronic-recipes"),
);
const LatestAuthorizations2 = React.lazy(
  () => import("../containers/CallCenterLayout/lastest-authorization-view/Latest-Authorizations"),
);
const HistoricalTransactions2 = React.lazy(
  () => import("../containers/CallCenterLayout/historical-transaction-view/HistoricalTransactions"),
);

export default function CallCenterRoutes({ profile, user, pharmacy }) {
  return (
    <>
      {/* ************************************Layout Call Center Farmacias********************************* */}
      {/* HomePage */}
      <Route exact path="/">
        <HomePageP2 profile={profile} user={user} pharmacy={pharmacy} />
      </Route>

      {/*Autorizaciones Layout*/}
      <Route exact path="/authorizations">
        <PharmacyLayout2 profile={profile} user={user} pharmacy={pharmacy} />
      </Route>

      {/*Recetas Electronicas Layout*/}
      <Route exact path="/electronic-recipes">
        <ElectronicRecipes2 profile={profile} user={user} pharmacy={pharmacy} />
      </Route>

      {/*Ultimas Autorizaciones Layout*/}
      <Route exact path="/lastest-authorizations">
        <LatestAuthorizations2 profile={profile} user={user} pharmacy={pharmacy} />
      </Route>

      {/*Histórico de Transacciones Layout*/}
      <Route exact path="/historical-transactions">
        <HistoricalTransactions2 profile={profile} user={user} pharmacy={pharmacy} />
      </Route>
    </>
  );
}
